<template>
  <div>
    <loading :status="loading" />
    <div v-if="!loading">
      <div class="space-x-2 flex justify-between">
        <qr-code v-if="order.qr_link" :size="Number(app.printer.qr_code_size)" :color="app.printer.font_color" :text="`${order.qr_link}`"></qr-code>
        <h2 class="w-full font-bold tracking-wider uppercase">
          <strong class="text-2xl">{{ app.name }}</strong>
          <small>
            <p v-if="app.phone">{{ app.phone }}</p>
            <p v-html="app.address"></p>
          </small>
        </h2>
      </div>
      <div class="flex items-center mt-2">
        <label class="min-w-32 block font-bold uppercase">{{ $t('Bill invoice date') }}</label>
        <span class="mr-4 inline-block">:</span>
        <div>{{ order.date }}</div>
      </div>
      <div class="flex items-center">
        <label class="min-w-32 block font-bold uppercase">{{ $t('Bill invoice time') }}</label>
        <span class="mr-4 inline-block">:</span>
        <div>{{ order.time }}</div>
      </div>
      <div class="flex items-center">
        <label class="min-w-32 block font-bold uppercase">{{ $t('Bill Invoice ID') }}</label>
        <span class="mr-4 inline-block">:</span>
        #{{ order.tracking }} [ {{ order.id }} ]
      </div>
      <div class="flex items-center">
        <label class="min-w-32 block font-bold uppercase">{{ $t('Tax Identity') }} ({{ $t('VAT') }})</label>
        <span class="mr-4 inline-block">:</span>
        #{{ order.tax.tax_id }}
      </div>
      <div class="w-full mb-1 mt-1 py-1 overflow-hidden">
          <div class="flex items-center">
            <label class="min-w-32 block font-bold uppercase">{{ $t('Customer name') }}</label>
            <span class="mr-4 inline-block">:</span>
            <div>{{ order.name | capitalize }}</div>
          </div>
      </div>
      <div class="flex items-center my-2">
        <table class="w-full">
          <thead>
            <tr>
              <th class="font-semibold uppercase tracking-wider">{{ $t('No') }}</th>
              <th class="w-full font-semibold uppercase tracking-wider text-left">{{ $t('Item') }}</th>
              <th class="font-semibold uppercase tracking-wider">{{ $t('Qty') }}</th>
              <th class="font-semibold uppercase tracking-wider">{{ $t('Price') }}</th>
              <th class="font-semibold uppercase tracking-wider">{{ $t('SubTotal') }}</th>
            </tr>
          </thead>
          <tbody class="divide divide-gray-200">
            <tr class="text-center" v-for="(item, index) in order.items" :key="index">
              <td>{{ index + 1 }}</td>
              <td class="text-left space-y-2">
                {{ item.name }}<br />
                {{ item.imei }}<br />
                {{ item.serial_number }}
              </td>
              <td>{{ item.qty }}</td>
              <td>{{ item.price | currency }}</td>
              <td>{{ item.sub_total | currency }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="w-full mb-1 mt-1 py-1 overflow-hidden">
        <div class="flex justify-between font-semibold">
          <p>{{ $t('Charges') }} :</p>
          <p>{{ order.charges | currency }}</p>
        </div>
        <div class="flex justify-between font-semibold">
          <template v-if="order.tax.is_tax_fix">
            <p>{{ $t('Tax') }} ({{ order.tax.rate }} {{ $t('fix') }}) :</p>
          </template>
          <template v-else>
            <p>{{ $t('Tax') }} ({{ order.tax.rate }}%) :</p>
          </template>
          <p>{{ order.tax_amount | currency }}</p>
        </div>
        <div class="flex justify-between font-semibold">
          <p>{{ $t('Total') }} :</p>
          <p>{{ order.total_amount | currency }}</p>
        </div>
      </div>
      <div class="pt-2">
        <div class="font-bold text-left">
          {{ $t('Description') }}
        </div>
        <div class="terms px-5 my-2">
          {{ order.description }}
        </div>
      </div>

      <div class="pt-2">
        <template v-if="app.terms.bills">
          <div class="font-bold text-left">
            {{ $t('I acknowledge the following terms and conditions') }}
          </div>
          <div class="terms px-5">
            <p v-html="app.terms.bills"></p>
          </div>
        </template>
        <div class="flex justify-between">
          <div class="font-bold flex-1">
            {{ $t('Signature') }}
          </div>
          <div class="font-sm">------------------------------</div>
        </div>
      </div>
      <div class="flex place-content-center">
        <barcode width="1" :lineColor="app.printer.font_color" :value="order.tracking" class="self-center" height="25" />
      </div>
    </div>
  </div>
</template>
<script>
import VueBarcode from 'vue-barcode';
import VueQRCodeComponent from 'vue-qrcode-component';

export default {
  name: 'custom-bill',
  metaInfo() {
    return {
      title: this.$i18n.t('Print bill order'),
    };
  },
  components: {
    'qr-code': VueQRCodeComponent,
    barcode: VueBarcode,
  },
  computed: {
    app() {
      return this.$store.getters['app/getSettings'];
    },
  },
  data() {
    return {
      loading: false,
      order: {
        qr_link: null,
        tax: {
          rate: 0,
          tax_id: null,
          is_tax_included: false,
          is_tax_fix: false,
        },
      },
    };
  },
  mounted() {
    this.getCustomBillOrder();
  },
  methods: {
    getCustomBillOrder() {
      this.loading = true;
      axios
        .get(route('print-custom-bill-order', this.$route.params.uuid))
        .then((response) => {
          this.order = response.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
